import { ArrowUpRight } from "lucide-react";
import { Kicker, Reveal, scrollToId } from "./Reveal";
import { STEPS } from "../data/content";

export const Process = () => (
  <section id="ablauf" className="bg-white py-24 md:py-32" data-testid="process-section">
    <div className="container-x">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-12 md:mb-16">
        <div>
          <Reveal>
            <Kicker>Der Ablauf</Kicker>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 data-testid="process-title" className="font-display text-4xl sm:text-5xl font-semibold tracking-tight leading-[1.08] mt-4 text-ink">
              In vier Schritten <span className="font-fraktur text-golddark">zum Ergebnis.</span>
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.16} className="max-w-md">
          <p className="text-muted leading-relaxed">
            Kein komplizierter Prozess, keine langen Wartezeiten: vier klare Schritte von der ersten Nachricht
            bis zur sauberen Übergabe.
          </p>
        </Reveal>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-x-10 gap-y-12">
        {STEPS.map((s, i) => (
          <Reveal key={s.num} delay={i * 0.07}>
            <div className="border-t-2 border-navy pt-6" data-testid={`process-step-${s.num}`}>
              <p className="font-mono font-bold text-3xl text-golddark">{s.num}</p>
              <h3 className="font-display text-xl font-semibold tracking-tight text-ink mt-4">{s.title}</h3>
              <p className="text-muted leading-relaxed mt-2.5 text-sm">{s.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2}>
        <button onClick={() => scrollToId("#kontakt")} data-testid="process-cta" className="btn-primary mt-12">
          Schritt 1 jetzt starten <ArrowUpRight size={16} />
        </button>
      </Reveal>
    </div>
  </section>
);
